module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/020712374240c3cc5a731984a6beb7bd.png";